var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card-text journey-planner" }, [
    _c("div", { class: _vm.journeyPlannerInputClasses }, [
      _c("div", { staticClass: "d-flex flex-column flex-md-row" }, [
        _c(
          "div",
          {
            staticClass:
              "d-lg-flex d-none d-md-flex justify-content-center align-items-baseline not-widget",
          },
          [
            _vm.alwaysShowForm
              ? [
                  _c("span", { staticClass: "d-none d-md-block d-lg-none" }, [
                    _vm._v("Find "),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "d-none d-lg-block" }, [
                    _vm._v("Show me "),
                  ]),
                ]
              : _c("span", { staticClass: "d-none d-lg-block" }, [
                  _vm._v("We're showing you "),
                ]),
            _vm._v(" "),
            _c("div", { staticClass: "h-24" }),
            _vm._v(" "),
            _c("span", { staticClass: "d-md-none mr-2 not-widget" }, [
              _vm._v(" journeys"),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "d-none d-md-block mr-2" }, [
              _c("span", { staticClass: "d-lg-inline d-none" }, [_vm._v("j")]),
              _c("span", { staticClass: "d-inline d-lg-none" }, [
                _vm._v(_vm._s(_vm.alwaysShowForm ? "j" : "J")),
              ]),
              _vm._v("ourneys from\n                "),
            ]),
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mr-md-2 flex-grow-1 position-relative" },
          [
            _c("label", { staticClass: "d-md-none small mb-0" }, [
              _vm._v("\n                    From:\n                "),
            ]),
            _vm._v(" "),
            _c("StationPicker", {
              ref: "fromStation",
              attrs: {
                placeholder: "Enter origin station...",
                "start-value": _vm.model.station.from.name
                  ? _vm.model.station.from.name
                  : null,
                "extra-classes": "from-station-input",
              },
              on: {
                pick: function (item) {
                  return (_vm.model.station.from = item)
                },
                emptied: function () {
                  return (_vm.model.station.from = { key: "", name: "" })
                },
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "mr-md-2 flex-grow-1 d-flex align-items-baseline position-relative",
          },
          [
            _c("span", { staticClass: "d-none d-md-block mr-2" }, [
              _vm._v("\n                    to\n                "),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "w-100", attrs: { id: "to-station" } },
              [
                _c("label", { staticClass: "d-md-none small mb-0" }, [
                  _vm._v("\n                        To:\n                    "),
                ]),
                _vm._v(" "),
                _c("StationPicker", {
                  attrs: {
                    placeholder: "Enter destination station...",
                    "start-value": _vm.model.station.to.name
                      ? _vm.model.station.to.name
                      : null,
                    "extra-classes": "to-station-input",
                  },
                  on: {
                    pick: function (item) {
                      return (_vm.model.station.to = item)
                    },
                    emptied: function () {
                      return (_vm.model.station.to = { key: "", name: "" })
                    },
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "invalid-feedback" }),
              ],
              1
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-block d-md-flex switch-stations-container" },
          [
            _c(
              "div",
              {
                staticClass: "btn-outer align-items-center switch-stations",
                attrs: { "aria-roledescription": "button", tabindex: "0" },
                on: {
                  click: _vm.switchStations,
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.switchStations($event)
                  },
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "d-none d-md-inline-block not-widget" },
                  [
                    _c("font-awesome-icon", {
                      staticClass: "ml-1 mr-1 switch-icon",
                      attrs: { icon: "fa-solid fa-arrow-right-arrow-left" },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "small d-md-none widget" },
                  [
                    _c("font-awesome-icon", {
                      staticClass: "mt-0 pt-0 ml-1 mr-1",
                      attrs: { icon: "fa-solid fa-arrow-down-arrow-up" },
                    }),
                    _vm._v(
                      "\n                        Swap\n                    "
                    ),
                  ],
                  1
                ),
              ]
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex flex-column flex-md-row" }, [
        _c("div", { staticClass: "d-flex align-items-baseline" }, [
          _c("span", { staticClass: "mr-2 d-none d-lg-block" }, [
            _vm._v("\n                    Leaving on\n                "),
          ]),
          _vm._v(" "),
          _c(
            "span",
            { staticClass: "mr-md-1 mr-lg-2 d-none d-md-block d-lg-none" },
            [_vm._v("\n                    Leaving\n                ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mr-md-1 mr-lg-2 w-100 w-md-auto" },
            [
              _c("label", { staticClass: "d-md-none small mb-0" }, [
                _vm._v(
                  "\n                        Leaving on:\n                    "
                ),
              ]),
              _vm._v(" "),
              _c(
                "date-picker",
                {
                  staticClass: "w-100",
                  attrs: {
                    id: "date-picker-outbound",
                    disruptions: _vm.disruptions,
                  },
                  on: {
                    input: function ($event) {
                      return _vm.dateChanged(true)
                    },
                  },
                  model: {
                    value: _vm.model.outbound,
                    callback: function ($$v) {
                      _vm.$set(_vm.model, "outbound", $$v)
                    },
                    expression: "model.outbound",
                  },
                },
                [
                  _vm._v(
                    "\n                        Add an outbound date\n                    "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", {
                staticClass: "invalid-feedback",
                attrs: { id: "outbound-date-warning" },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-flex align-items-baseline" },
          [
            _vm.isValidDate(_vm.model.return)
              ? [
                  _c("span", { staticClass: "mr-2 d-none d-lg-block" }, [
                    _vm._v(
                      "\n                        and returning on\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass:
                        "mr-md-1 mr-lg-2 d-none d-md-block d-lg-none",
                    },
                    [
                      _vm._v(
                        "\n                        returning\n                    "
                      ),
                    ]
                  ),
                ]
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "w-100 w-md-auto", attrs: { id: "return-date" } },
              [
                _vm.model.return.date
                  ? _c("span", { staticClass: "d-md-none small mb-0" }, [
                      _vm._v(
                        "\n                        Returning on:\n                    "
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "date-picker",
                  {
                    ref: "returnDatePicker",
                    attrs: {
                      id: "date-picker-return",
                      min: _vm.model.outbound.date,
                      removable: true,
                      disruptions: _vm.disruptions,
                    },
                    on: {
                      input: function ($event) {
                        return _vm.dateChanged(false)
                      },
                    },
                    model: {
                      value: _vm.model.return,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "return", $$v)
                      },
                      expression: "model.return",
                    },
                  },
                  [
                    _vm._v(
                      "\n                        Add a return...\n                    "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "invalid-feedback" }),
              ],
              1
            ),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex flex-column flex-md-row" }, [
        _c("div", { staticClass: "d-flex align-items-baseline" }, [
          _c("label", { staticClass: "mr-2" }, [
            _c("input", {
              ref: "oneWayJourneyCheckbox",
              attrs: { type: "checkbox" },
              on: { input: _vm.clickOneWayJourney },
            }),
            _vm._v(" One-way journey\n                "),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "d-flex align-items-center flex-wrap",
          attrs: { id: "buttons" },
        },
        [
          _vm.isDevApi()
            ? _c(
                "button",
                {
                  staticClass: "btn btn-outline-info mr-2",
                  on: {
                    click: function ($event) {
                      return _vm.lichfield()
                    },
                  },
                },
                [_vm._v("\n                Lichfield\n            ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("passenger-picker", {
            ref: "paxPicker",
            attrs: { value: _vm.model.passengers, railcards: _vm.railcards },
            on: { input: _vm.updatePassengers },
          }),
          _vm._v(" "),
          _vm._l(_vm.selectedOptions, function (option) {
            return _c(
              "input-button",
              {
                key: option,
                attrs: {
                  icon: _vm.optionIcon(option),
                  "data-toggle": "modal",
                  "data-target": "#moreOptionsModal",
                  "data-backdrop": "static",
                  "data-keyboard": "false",
                },
                on: {
                  "click-inner": function ($event) {
                    return _vm.remove(option)
                  },
                },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.optionDisplay(option)) +
                    "\n            "
                ),
              ]
            )
          }),
          _vm._v(" "),
          _c(
            "input-button",
            {
              attrs: {
                icon: "add",
                type: "dashed",
                "data-toggle": "modal",
                "data-target": "#moreOptionsModal",
                "data-backdrop": "static",
                "data-keyboard": "false",
                "use-click-event-for-all": true,
              },
            },
            [_vm._v("\n                More Options\n            ")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: _vm.isRequestValid ? null : _vm.invalidReason,
                  expression: "isRequestValid ? null : invalidReason",
                },
              ],
              staticClass: "btn search",
              class: _vm.buttonClasses,
              attrs: { disabled: !_vm.isRequestValid },
              on: { click: _vm.didClickSearch },
            },
            [
              _c("SearchButtonLoadingSpinner"),
              _vm._v(
                "\n                " +
                  _vm._s(_vm.buttonLabel) +
                  "\n            "
              ),
            ],
            1
          ),
        ],
        2
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: {
          id: "moreOptionsModal",
          tabindex: "-1",
          role: "dialog",
          "aria-labelledby": "moreOptionsModalLabel",
          "aria-hidden": "true",
        },
      },
      [
        _c(
          "div",
          { staticClass: "modal-dialog", attrs: { role: "document" } },
          [
            _c("div", { staticClass: "modal-content" }, [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "div",
                {
                  ref: "scrollableContent",
                  staticClass: "modal-body more-options",
                },
                [
                  _c(
                    "div",
                    { staticClass: "card-text options-container" },
                    [
                      _c("options-group", {
                        ref: "moreOptionsGroup",
                        attrs: { config: _vm.moreOptionsModalConfig },
                        on: { input: _vm.checkForConflictingOptions },
                        model: {
                          value: _vm.modifiedOptions,
                          callback: function ($$v) {
                            _vm.modifiedOptions = $$v
                          },
                          expression: "modifiedOptions",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn",
                    attrs: {
                      id: "cancel-button",
                      type: "button",
                      "data-dismiss": "modal",
                    },
                    on: { click: _vm.resetModifiedOptions },
                  },
                  [
                    _vm._v(
                      "\n                        Cancel\n                    "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    attrs: { id: "apply-button", type: "button" },
                    on: { click: _vm.apply },
                  },
                  [
                    _vm._v(
                      "\n                        Apply\n                    "
                    ),
                  ]
                ),
              ]),
            ]),
          ]
        ),
        _vm._v("\n        .\n    "),
      ]
    ),
    _vm._v(" "),
    _vm._m(1),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "h5",
        { staticClass: "modal-title", attrs: { id: "moreOptionsModalLabel" } },
        [_vm._v("\n                        More Options\n                    ")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close",
          },
        },
        [
          _c("span", { attrs: { "aria-hidden": "true" } }, [
            _vm._v("\n                            ×\n                        "),
          ]),
        ]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: {
          id: "tcbc-migration",
          tabindex: "-1",
          role: "dialog",
          "aria-hidden": "true",
        },
      },
      [
        _c(
          "div",
          {
            staticClass: "modal-dialog modal-dialog-centered",
            attrs: { role: "document" },
          },
          [
            _c("div", { staticClass: "modal-content" }, [
              _c(
                "div",
                {
                  staticClass:
                    "modal-body d-flex flex-column align-items-center p-2 md:p-0",
                },
                [
                  _c("img", {
                    staticClass: "mb-5 mt-3",
                    attrs: { src: "/images/tcbc.png", alt: "TCBC" },
                  }),
                  _vm._v(" "),
                  _c("h4", { staticClass: "text-blue-dark mb-4 text-center" }, [
                    _vm._v(
                      "\n                        TrainsCanBeCheaper has merged with TrainSplit\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "text-center lead" }, [
                    _vm._v(
                      "\n                        trainscanbecheaper.info used to offer an online booking engine without splits.\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "text-center mb-3" }, [
                    _vm._v(
                      "\n                        It's now entirely possible on the TrainSplit website to turn off splits; which we've done for you.\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-lg btn-outline-primary",
                      attrs: { id: "tcbc-ok" },
                    },
                    [
                      _vm._v(
                        "\n                        Got it!\n                    "
                      ),
                    ]
                  ),
                ]
              ),
            ]),
          ]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }